import type { Translate } from 'next-translate'

import { SessionTypeFilter, SessionTypeFilterSchema } from '@/src/domains/therapist-filters/constants'

const sessionTypeTextMap: Record<SessionTypeFilter, string> = {
  [SessionTypeFilter.ALL]: 'component.therapist.filter.event-type.all',
  [SessionTypeFilter.ONLINE]: 'component.therapist.filter.event-type.online',
  [SessionTypeFilter.OFFLINE]: 'component.therapist.filter.event-type.offline',
  [SessionTypeFilter.HYBRID]: 'component.therapist.filter.event-type.combined',
}

export const getTherapistSessionTypeFilterName = (type: unknown, t: Translate) => {
  const sessionType = SessionTypeFilterSchema.safeParse(type)

  if (sessionType.success) {
    return t(sessionTypeTextMap[sessionType.data])
  }

  return null
}
